import { createFileRoute, redirect } from "@tanstack/react-router";
import { getCoachByUsername } from "~/lib/server/coach";

export const Route = createFileRoute("/_public/discovery/$username/offer/")({
  loader: async ({ params }) => {
    const username = params.username;
    const coach = await getCoachByUsername(username);

    if (!coach?.mainOfferId) {
      throw redirect({
        to: "/discovery/$username",
        params: { username },
      });
    }

    throw redirect({
      to: "/$username",
      params: { username },
    });
  },
});
